import type { ReactNode } from 'react';
import React, { createContext, useCallback, useMemo, useState } from 'react';
import _noop from 'lodash/noop';
type PropsT = {
  children: ReactNode;
  skipFrameTime?: number;
  frameRate?: number;
};
type ModalPropsT = {
  closeModal: () => void;
  isOpen: boolean;
};
type ModalConfigT = {
  ModalComponent: (props: ModalPropsT) => React.ReactNode;
};
export const ModalWrapperContext = createContext<{
  openModal: (x: ModalConfigT) => void;
}>({
  openModal: _noop
});
export const ModalWrapperProvider = ({
  children
}: PropsT) => {
  const [ModalConfig, setModalConfig] = useState<ModalConfigT | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const openModal = useCallback((modalConfig: ModalConfigT) => {
    setModalConfig(modalConfig);
    setIsModalOpen(true);
  }, []);
  const value = useMemo(() => ({
    openModal
  }), [openModal]);
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setModalConfig(null);
  }, []);
  return <ModalWrapperContext.Provider value={value}>
      {<>
          {children}
          {isModalOpen && ModalConfig ? <ModalConfig.ModalComponent closeModal={closeModal} isOpen={isModalOpen}></ModalConfig.ModalComponent> : null}
        </>}
    </ModalWrapperContext.Provider>;
};